import React, {useEffect, useState} from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";

import WithUserData from "../../WithUserData";
import { useMutation } from "@apollo/client";

import styles from "../../../TalentApplication/styles.module.css";
import isChecked from "../../../TalentApplication/StepPhotos_5th/insta-checkmark.svg";
import {INSTAGRAM_THUMBNAIL_URL, UPDATE_USER_PHOTOS} from "../../WithUserData/queries";
import blankImage from "../../../../assets/images/blank.gif";
import Spinner from "../../../../assets/Spinner/Spinner";
import removeHash from "../../../../utils/location";
import qs from "query-string";
import fetchJsonp from "fetch-jsonp";
import {Link} from "react-router-dom";

const ImagesPicker = ({ user, history }) => {

    const maxNumberOfImages = 6;
    const minNumberOfImages = 6;
    const [ instagramThumbnailUrl ] = useMutation(INSTAGRAM_THUMBNAIL_URL)
    const [ updateUserPhotos ] = useMutation(UPDATE_USER_PHOTOS);

    const [imagesSelected, setImagesSelected] = useState([]);
    const [isNextPage, setIsNextPage] = useState(false);
    const [classNextPage, setClassNextPage] = useState("");
    const [imageData, setImageData] = useState({});
    const [connectedInstagramHandle, setConnectedInstagramHandle] = useState(null);
    const [ loading, setLoading ] = useState(true)

    useEffect(() => {
        if (isNextPage) handleNextPage();
    }, [isNextPage]);

    const invalidTokenCallback = (error) => {
        if(error)
            console.log(error);
        history.push('/account/instagram/connect');
    }

    useEffect(() => {
        const instagramConnectAccessToken = localStorage.getItem("instagram_access_token");
        const dbInstagramAccessToken = user.instagramToken;
        if(!dbInstagramAccessToken) {
            invalidTokenCallback()
        }
        fetchImages(instagramConnectAccessToken || dbInstagramAccessToken);
    }, []);


    const fetchImages = async (instagramAccessToken) => {
        removeHash();

        const queryString = qs.stringify({
            access_token: instagramAccessToken,
        });

        const body = await fetchJsonp(
            "https://graph.instagram.com/v21.0/me/media/?fields=id,media_type,media_url,permalink,children{media_type, media_url,permalink},username&" +
            queryString,
        ).then((res) => res.json())
        .catch (error => {
            // Failed to fetch instagram account images, invalid token
            invalidTokenCallback(error)
        });
        if (!body.data) {
            // Failed to fetch instagram account images, invalid token
            invalidTokenCallback(body.error)
        }
        else
            handleImages(body);
    };

    const handleImages = (body) => {
        setLoading(false)
        let images = [];
        const media = body.data.filter(
            (media) =>
                media.media_type === "IMAGE" || media.media_type === "CAROUSEL_ALBUM"
        );

        if (media.length > 0) {
            media.forEach((post) => {
                if (post.children) {
                    const postChildren = post.children.data.filter(
                        (child) =>
                            child.media_type === "IMAGE" || child.media_type === "CAROUSEL_ALBUM"
                    );

                    if (postChildren.length > 0) {
                        const carouselRootPermalink = postChildren[0].permalink;
                        postChildren.forEach((child, index) => {
                            child.carouselRootPermalink = carouselRootPermalink;
                            child.carouselChildIndex = index + 1;
                        });
                    }

                    images = images.concat(postChildren);
                } else {
                    images.push(post);
                }
            });
            setConnectedInstagramHandle(media[0].username);
        }

        setImageData((prev) => ({
            images: (prev?.images || []).concat(images),
            paging: body.paging
        }));

        for (const singleMedia of media) {
            if (singleMedia.media_type === "CAROUSEL_ALBUM") {
                for (const carouselMedia of singleMedia.children.data) {
                    retrieveThumbnail(carouselMedia);
                }
            } else {
                retrieveThumbnail(singleMedia);
            }
        }
    };
    const retrieveThumbnail = async (carouselMedia) => {
        try {
            const res = await instagramThumbnailUrl({
                variables: {
                    instagramMediaPermalink: carouselMedia.permalink,
                    large: true,
                },
            });
            carouselMedia.thumbnail_url = res.data.instagramThumbnailUrl;
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const toggleImage = (image) => {
        const exists = imagesSelected.find((img) => img.id === image.id);
        if (exists) {
            setImagesSelected(imagesSelected.filter((img) => img.id !== image.id));
        } else if (imagesSelected.length < maxNumberOfImages) {
            setImagesSelected([...imagesSelected, image]);
        }
    };

    const handleNextPage = async () => {
        if (!imageData?.paging?.next) return;

        const body = await fetchJsonp(imageData.paging.next).then((res) => res.json());
        setClassNextPage(styles.list_image_active_next_page);
        setTimeout(() => setClassNextPage(""), 2000);
        handleImages(body);
        setIsNextPage(false);
    };

    const submitNewPhotos = async () => {
        const input = {
            _id: user._id,
            connectedInstagramHandle,
            images: imagesSelected
        }
        try {
            const res = await updateUserPhotos({
                variables: { input }
            });
            if(res.data?.updateUserPhotos) {
                history.push('/account/instagram');
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <>
            {loading &&
                <div className={`w-full h-full ${styles.Loading}`}>
                    <Spinner color='black' />
                </div>
            }
            {!loading && (<div className='w-full h-full flex flex-col justify-between px-2'>
                <div className="w-full h-16 flex items-center justify-between mt-6">
                    <Link
                        to="/account/instagram"
                        className="cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center hover:bg-gray-200"
                    >
                        <div className="w-10 flex items-center justify-center">
                            <MdOutlineArrowBackIos size={18}/>
                        </div>
                        <span>Back</span>
                    </Link>
                    <div className={`${styles.image_count} text-black`}>{imagesSelected.length}/6 selected</div>
                    <div
                        className={`w-24 py-2 rounded-lg border flex items-center justify-center 
                            ${imagesSelected.length < minNumberOfImages ? 'border-gray-400 bg-gray-200 text-gray-400 cursor-not-allowed' : 'border-black text-gray-900 cursor-pointer hover:bg-gray-200'}`}
                        onClick={() => {
                            if ( imagesSelected.length >= minNumberOfImages ) {
                                submitNewPhotos()
                            }
                        }}
                    >
                        Save
                    </div>
                </div>
                <div className={`flex-1 flex flex-col overflow-hidden mt-4 ${styles.step_five} `}>
                        <p className='text-black'>
                            Your account @
                            {connectedInstagramHandle || "Unknown"}{" "}
                            is connected. <br />
                        </p>
                        <Link
                            to="/account/instagram/connect"
                            className="w-full text-center text-black underline mb-4 mt-2"
                        >
                            Switch account?
                        </Link>
                        {imageData?.images?.length < 6 && (
                            <p className={styles.error_message}>
                                Your Instagram account has less than 6 photos. <br />
                                You need at least 6 photos to continue.
                            </p>
                        )}
                        {imageData?.images?.length >= 6 && (
                            <>
                                <p className='text-black'>
                                    Select pics that best represent <br /> you and your work
                                </p>
                            </>
                        )}
                        <div className={`h-full overflow-hidden ${classNextPage} my-5`}>
                            <div className={`${styles.list_image} ${styles.select_photos_white_theme}`}
                                onScroll={(e) => {
                                     const el = e.target;
                                     if (el.scrollHeight - el.scrollTop <= el.clientHeight + 1) {
                                         setIsNextPage(true);
                                     }
                                 }}
                            >
                                {imageData?.images?.map((image) => (
                                    <div
                                        key={image.id}
                                        className={styles.image}
                                        onClick={() => toggleImage(image)}
                                        style={{ cursor: imageData?.images?.length >= 6 ? "pointer" : "default" }}
                                    >
                                        <img
                                            src={blankImage}
                                            style={{ backgroundImage: `url(${image.media_url})` }}
                                            alt=""
                                        />
                                        {imagesSelected.find((img) => img.id === image.id) && (
                                            <img src={isChecked} className={styles.selected_image} alt="selected" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
            </div>)}
        </>
    )
}

const SelectPhotos = ({history}) => {
    return (
        <WithUserData>
            {({ user }) => <ImagesPicker user={user} history={history} />}
        </WithUserData>
    );
};

export default SelectPhotos;